import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import Button from '@mulesoft/anypoint-components/lib/Button';
import Tooltip from '@mulesoft/anypoint-components/lib/Tooltip';
import Icon from '@mulesoft/anypoint-icons/lib/Icon';
import { getPath } from '~/utils/routes';
import styles from './Header.css';

const Header = ({ emptyState, agentCapacity }) => {
  const addScannerPath = getPath('agentScannersAdd');
  const showCapacity =
    agentCapacity &&
    typeof agentCapacity.used === 'number' &&
    typeof agentCapacity.total === 'number';

  return (
    <div
      className={styles.headerBar}
      data-test-id="scan-configurations-section-header"
    >
      <div>
        <h2>Scanners</h2>
        {showCapacity && (
          <React.Fragment>
            <span className={styles.headerBarTitle}>
              Service Capacity Used:{' '}
              <strong>
                {agentCapacity.used} / {agentCapacity.total}
              </strong>{' '}
            </span>
            <span>
              <Tooltip
                ariaDescribedByTrigger="test-tooltip-info-capacity"
                content="Future services import will be blocked once the total capacity is reached. Contact your administrator to increase the capacity."
                position="right"
                testId="info-tooltip-capacity"
              >
                <Icon
                  name="info"
                  size={20}
                  title="Info icon"
                  aria-label="Info icon"
                />
              </Tooltip>
            </span>
          </React.Fragment>
        )}
      </div>
      <div
        className={styles.headerBarActions}
        data-test-id="scan-configurations-section-buttons"
      >
        <Link to={addScannerPath} display-if={!emptyState}>
          <Button
            type="button"
            kind="primary"
            data-test-id="add-scanner-button"
          >
            Add Scanner
          </Button>
        </Link>
      </div>
    </div>
  );
};

Header.propTypes = {
  emptyState: PropTypes.bool,
  agentCapacity: PropTypes.shape({
    used: PropTypes.number,
    total: PropTypes.number
  })
};

export default Header;
